<template>
   <div>
      <a class="backBtn" :href="`/#/essential/mission/${missionId}`">
         <img src="/img/back-icon.png" />
      </a>
      <div v-if="isIframe">
         <div class="background-activities"
            :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
            <div class="sideBar">
               <h1>Downloadables</h1>
               <div class="list">
                  <div class="button-container" v-if="hasMisionPrimaria">
                     <button class="active" @click="goToSpanishVersion">
                        Recursos en español
                        <img src="../assets/img/mexico.png" class="imgmx" />
                     </button>
                  </div>
                  <div class="button-container">
                     <button class="active" @click="showCurse(1)">
                        Downloadables
                     </button>
                  </div>
                  <div class="button-container">
                     <button @click="showVideo()">Video</button>
                  </div>
                  <div class="button-container">
                     <button @click="showAudio()">Audios</button>
                  </div>
               </div>
            </div>
            <div class="container-resources" v-if="isDownloadable">
               <template v-for="(actividad, index) in recursos">
                  <h2 class="recursos" :key="index" v-if="actividad.grado === missionId && actividad.tipo === isAsignatura
                     ">
                     {{ actividad.titulo }}
                     <br />
                     <button @click="downloadIframe(actividad.url)">
                        Trimester 1
                     </button>
                     <button @click="downloadIframe(actividad.url2)">
                        Trimester 2
                     </button>
                     <button @click="downloadIframe(actividad.url3)">
                        Trimester 3
                     </button>
                  </h2>
               </template>
            </div>
            <div class="container-videos" v-if="isVideo">
               <div class="tab-trim">
                  <button @click="changeTrim(1)" :class="trim === 1 ? 'active' : ''">
                     Trimester 1
                  </button>
                  <button @click="changeTrim(2)" :class="trim === 1 ? 'active' : ''">
                     Trimester 2
                  </button>
                  <button @click="changeTrim(3)" :class="trim === 1 ? 'active' : ''">
                     Trimester 3
                  </button>
               </div>
               <div class="container-buttons">
                  <template v-for="(video, index) in videos">
                     <button :key="index" @click="showIframe(video.url)"
                        v-if="video.grade === missionId && video.trim === trim" class="">
                        {{ video.title }}
                     </button>
                  </template>
               </div>
            </div>
            <div class="container-videos" v-if="isAudio">
               <div class="tab-trim">
                  <button @click="changeTrim(1)" :class="trim === 1 ? 'active' : ''">
                     Trimester 1
                  </button>
                  <button @click="changeTrim(2)" :class="trim === 2 ? 'active' : ''">
                     Trimester 2
                  </button>
                  <button @click="changeTrim(3)" :class="trim === 3 ? 'active' : ''">
                     Trimester 3
                  </button>
               </div>
               <div class="container-buttons-audio">
                  <template v-for="(audio, index) in audios">
                     <iframe width="100%" height="450" scrolling="no" frameborder="no" allow="autoplay" :key="index"
                        :src="`${audio.src}`" v-if="audio.grade === missionId && audio.trim === trim"></iframe>
                  </template>
               </div>
            </div>
         </div>
      </div>
      <div v-else>
         <div class="screen-container-book"
            :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
            <iframe width="835" height="432" :src="`https://player.vimeo.com/video/${iframeId}`" frameborder="0"
               allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
         </div>
      </div>
   </div>
</template>
<script>
import Auth from "../services/Auth";
import NProgress from "nprogress";
import Button from "../components/Button.vue";

export default {
   components: { Button },
   name: "resources",
   async created() {
      this.init();
      NProgress.done();
   },
   computed: {
      missionId() {
         return parseInt(this.$route.params.missionId);
      },
      hasMisionPrimaria() {
      return this.essentials.some(item =>
        item.includes('Misión Primaria')
      );
    },
   },
   data() {
      return {
         isIframe: true,
         isDownloadable: true,
         isVideo: false,
         isAudio: false,
         iframeId: "",
         isAsignatura: 1,
         trim: 1,
         essentials: [],
         recursos: [
            // -------------------------   NIVEL 1 -----------------------------------
            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV1_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV1_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV1_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 1,
            },
            // -------------------------   NIVEL 2 -----------------------------------
            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV2_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV2_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV2_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 2,
            },

            // -------------------------   NIVEL 3 -----------------------------------
            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV3_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV3_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV3_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 3,
            },
            // -------------------------   NIVEL 4 -----------------------------------
            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV4_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV4_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV4_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 4,
            },

            // -------------------------   NIVEL 5 -----------------------------------
            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV5_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV5_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV5_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 5,
            },

            // -------------------------   NIVEL 6 -----------------------------------

            {
               url: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim1/FFE_ESSENTIALS_NIV6_TRIM1_SB_DOWNLOADABLES.pdf",
               url2: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim2/FFE_ESSENTIALS_NIV6_TRIM2_SB_DOWNLOADABLES.pdf",
               url3: "https://storage.googleapis.com/mision-recursos-descargables/3Ed/Essential/Downloadables/trim3/FFE_ESSENTIALS_NIV6_TRIM3_SB_DOWNLOADABLES.pdf",
               titulo: "Downloadables",
               tipo: 1,
               grado: 6,
            },
         ],
         videos: [
            {
               grade: 1,
               title: "I lost my pet",
               url: "853129027",
               trim: 1,
            },
            {
               grade: 1,
               title: "Special celebrations in my family",
               url: "853129050",
               trim: 1,
            },
            {
               grade: 1,
               title: "Phases of the moon",
               url: "853129075",
               trim: 1,
            },
            {
               grade: 1,
               title: "Tammy and Tom´s birthday party",
               url: "853129075",
               trim: 1,
            },
            {
               grade: 1,
               title: "The five senses",
               url: "853129115",
               trim: 1,
            },
            {
               grade: 1,
               title: "Earth, the Continents, and the Oceans",
               url: "889549856",
               trim: 2
            },
            {
               grade: 1,
               title: "Mike the Dreamer",
               url: "889549895",
               trim: 2
            },
            {
               grade: 1,
               title: "Ecosystems",
               url: "889549938",
               trim: 2
            },
            {
               grade: 1,
               title: "Healthy Habits",
               url: "889549981",
               trim: 2
            },
            {
               grade: 1,
               title: "The lion and the Mouse",
               url: "889550010",
               trim: 2
            },
            {
               grade: 1,
               title: "The Amazing Pyramid Tour!",
               url: "915975909",
               trim: 3
            },
            {
               grade: 1,
               title: "Where Does Water Come From?",
               url: "915975939",
               trim: 3
            },
            {
               grade: 1,
               title: "The Sun and the Seasons",
               url: "915975960",
               trim: 3
            },
            {
               grade: 1,
               title: "America: The New Continent",
               url: "915975986",
               trim: 3
            },
            {
               grade: 1,
               title: "Animals and Plants",
               url: "915976006",
               trim: 3
            },
            {
               grade: 2,
               title: "African Giants",
               url: "853129579",
               trim: 1,
            },
            {
               grade: 2,
               title: "My family tree",
               url: "853129579",
               trim: 1,
            },
            {
               grade: 2,
               title: "The planets around us",
               url: "853129628",
               trim: 1,
            },
            {
               grade: 2,
               title: "Life in the 16th century",
               url: "853129655",
               trim: 1,
            },
            {
               grade: 2,
               title: "The fox and the grapes",
               url: "853129673",
               trim: 1,
            },
            {
               grade: 2,
               title: "States of Matter",
               url: "889556563",
               trim: 2,
            },
            {
               grade: 2,
               title: "Martin Luther King",
               url: "889556599",
               trim: 2,
            },
            {
               grade: 2,
               title: "Endangered Animals",
               url: "889556619",
               trim: 2,
            },
            {
               grade: 2,
               title: "The Mayas",
               url: "889556645",
               trim: 2,
            },
            {
               grade: 2,
               title: "The Elves and the Shoemaker",
               url: "889556666",
               trim: 2,
            },
            {
               grade: 2,
               title: "Flags",
               url: "916055558",
               trim: 3
            },
            {
               grade: 2,
               title: "Working Dogs?",
               url: "916055584",
               trim: 3
            },
            {
               grade: 2,
               title: "Natural and Artificial Sources of Light",
               url: "916055606",
               trim: 3
            },
            {
               grade: 2,
               title: "Great Civilizations",
               url: "916055655",
               trim: 3
            },
            {
               grade: 2,
               title: "The Prince and the Painted Lion",
               url: "916055628",
               trim: 3
            },
            {
               grade: 3,
               title: "Art all around us",
               url: "853129793",
               trim: 1,
            },
            {
               grade: 3,
               title: "A trip to prehistoric caves",
               url: "853129822",
               trim: 1,
            },
            {
               grade: 3,
               title: "Oxygen",
               url: "853129836",
               trim: 1,
            },
            {
               grade: 3,
               title: "Spain and England in America",
               url: "853129867",
               trim: 1,
            },
            {
               grade: 3,
               title: "Mercury and the Woodsman",
               url: "853129894",
               trim: 1,
            },
            {
               grade: 3,
               title: "Mr. Atom",
               url: "889568361",
               trim: 2
            },
            {
               grade: 3,
               title: "Volcanoes",
               url: "889568415",
               trim: 2
            },
            {
               grade: 3,
               title: "Young People Who Changed the World",
               url: "889568452",
               trim: 2
            },
            {
               grade: 3,
               title: "Medical Specialties",
               url: "889568486",
               trim: 2
            },
            {
               grade: 3,
               title: "Fantastic Creatures",
               url: "889568511",
               trim: 2
            },
            {
               grade: 3,
               title: "Ecosystems",
               url: "916069079",
               trim: 3
            },
            {
               grade: 3,
               title: "Olympic Games",
               url: "916069119",
               trim: 3
            },
            {
               grade: 3,
               title: "The Sound Mission",
               url: "916069140",
               trim: 3
            },
            {
               grade: 3,
               title: "The Four Oxen and the Lion",
               url: "916069167",
               trim: 3
            },
            {
               grade: 3,
               title: "The Thirteen Colonies",
               url: "916069194",
               trim: 3
            },
            {
               grade: 4,
               url: "853131896",
               title: "My travel journal",
               trim: 1,
            },
            {
               grade: 4,
               url: "853131921",
               title: "A history of time",
               trim: 1,
            },
            {
               grade: 4,
               url: "853131954",
               title: "Inside computers",
               trim: 1,
            },
            {
               grade: 4,
               url: "853131983",
               title: "The great philosophers",
               trim: 1,
            },
            {
               grade: 4,
               url: "853131998",
               title: "Surrounded by robots",
               trim: 1,
            },
            {
               grade: 4,
               title: "Watching Animals Migrate from a Ballon",
               url: "889572665",
               trim: 2
            },
            {
               grade: 4,
               title: "Gravity on Earth",
               url: "889572711",
               trim: 2
            },
            {
               grade: 4,
               title: "Rome and Greece",
               url: "889572752",
               trim: 2
            },
            {
               grade: 4,
               title: "Space Travelers",
               url: "889572772",
               trim: 2
            },
            {
               grade: 4,
               title: "Jules Verne",
               url: "889572805",
               trim: 2
            },
            {
               grade: 4,
               title: "The Vikings",
               url: "916078866",
               trim: 3
            },
            {
               grade: 4,
               title: "Hobbies and Entertainment",
               url: "916078907",
               trim: 3
            },
            {
               grade: 4,
               title: "Magnetism",
               url: "916078938",
               trim: 3
            },
            {
               grade: 4,
               title: "Paper Boats and Twelve O'Clock",
               url: "916078961",
               trim: 3
            },
            {
               grade: 4,
               title: "The Thirteen Colonies",
               url: "916078995",
               trim: 3
            },
            {
               grade: 5,
               url: 853133170,
               title: "How old are humans",
               trim: 1,
            },
            {
               grade: 5,
               url: 853133192,
               title: "Life in a green world",
               trim: 1,
            },
            {
               grade: 5,
               url: 853133214,
               title: "I Health day at school",
               trim: 1,
            },
            {
               grade: 5,
               url: 853133241,
               title: "The marathon",
               trim: 1,
            },
            {
               grade: 5,
               url: 853133263,
               title: "Diary of a pilgrim girl",
               trim: 1,
            },
            {
               grade: 5,
               title: "Your Body Systems: The Perfect Machine",
               url: "889577143",
               trim: 2
            },
            {
               grade: 5,
               title: "Prehistoric Animals",
               url: "889577118",
               trim: 2
            },
            {
               grade: 5,
               title: "Underwater Wonders",
               url: "889577091",
               trim: 2
            },
            {
               grade: 5,
               title: "Don Quixote Cervantes' Masterpiece",
               url: "889577058",
               trim: 2
            },
            {
               grade: 5,
               title: "Heroes",
               url: "889577014",
               trim: 2
            },
            {
               grade: 5,
               title: "Solar and Lunar Eclipses",
               url: "916095688",
               trim: 3
            },
            {
               grade: 5,
               title: "Clothing",
               url: "916095716",
               trim: 3
            },
            {
               grade: 5,
               title: "The Signing of the US Constitution",
               url: "916095737",
               trim: 3
            },
            {
               grade: 5,
               title: "Fire at the Globe Theatre",
               url: "916095757",
               trim: 3
            },
            {
               grade: 5,
               title: "Electricity",
               url: "916095777",
               trim: 3
            },
            {
               grade: 6,
               url: 853133428,
               title: "Healthy food and exercise",
               trim: 1,
            },
            {
               grade: 6,
               url: 853133447,
               title: "Astrologists and Astronomers ",
               trim: 1,
            },
            {
               grade: 6,
               url: 853133472,
               title: "Theree Fables",
               trim: 1,
            },
            {
               grade: 6,
               url: 853133498,
               title: "Live streaming of the olympics",
               trim: 1,
            },
            {
               grade: 6,
               url: 853133522,
               title: "American independence",
               trim: 1,
            },
            {
               grade: 6,
               title: "The Adventure of an Aluminum Can",
               url: "889588189",
               trim: 2
            },
            {
               grade: 6,
               title: "Bats are Useful Creatures",
               url: "889588232",
               trim: 2
            },
            {
               grade: 6,
               title: "World Heritage",
               url: "889588255",
               trim: 2
            },
            {
               grade: 6,
               title: "Mesoamerican Civilizations",
               url: "889588293",
               trim: 2
            },
            {
               grade: 6,
               title: "Discrimination",
               url: "889588322",
               trim: 2
            },
            {
               grade: 6,
               title: "The Industrial Revolution",
               url: "916108850",
               trim: 3
            },
            {
               grade: 6,
               title: "Natural Disasters",
               url: "916108883",
               trim: 3
            },
            {
               grade: 6,
               title: "From Airplanes to Spacecraft",
               url: "916108903",
               trim: 3
            },
            {
               grade: 6,
               title: "Literature Collection",
               url: "916108926",
               trim: 3
            },
            {
               grade: 6,
               title: "Animal Migration",
               url: "916108957",
               trim: 3
            },
            {
               grade: 6,
               title: "20,000 Leagues Under the Sea",
               url: "916108976",
               trim: 3
            }
         ],
         audios: [
            {
               grade: 1,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669158907%3Fsecret_token%3Ds-FEe7M3KClzW&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 1,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730426724%3Fsecret_token%3Ds-Z0evPbjS0QB&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2,
            },
            {
               grade: 1,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782678474&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            },
            {
               grade: 2,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669161807%3Fsecret_token%3Ds-PNQ0hjaxELy&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 2,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730966475%3Fsecret_token%3Ds-9iyC5CF9Cot&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2
            },
            {
               grade: 2,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782694719&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            },
            {
               grade: 3,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669163219%3Fsecret_token%3Ds-gDNLj8Lm0gT&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 3,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730968212%3Fsecret_token%3Ds-uR976x5gmCo&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2
            },
            {
               grade: 3,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782705903&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            },
            {
               grade: 4,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669164935%3Fsecret_token%3Ds-27mdfVSHVMD&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 4,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730975511%3Fsecret_token%3Ds-AsrrLvh0RdY&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2
            },
            {
               grade: 4,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782708813&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            },
            {
               grade: 5,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669166091%3Fsecret_token%3Ds-M8GNoSDv6Gi&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 5,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730996487%3Fsecret_token%3Ds-mvMH6V3RXYB&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2
            },
            {
               grade: 5,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782710259&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            },
            {
               grade: 6,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1669167147%3Fsecret_token%3Ds-COqZl30QooA&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 1,
            },
            {
               grade: 6,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1730997294%3Fsecret_token%3Ds-bY2f0d77Y9M&color=%23b8e0d4&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 2
            },
            {
               grade: 6,
               src: "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1782724092&color=%23ff5500&auto_play=false&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=false",
               trim: 3
            }
         ],
      };
   },
   methods: {
      init() { },
      changeTrim(trim) {
         this.trim = trim;
      },
      init() {
    try {
      const foundStudent = this.$store.state.session.currentUser.roles.find(
        element => element.role.code === "STUDENT"
      );
      if (foundStudent) {
        this.gradeData = this.$store.state.session.currentGrade.data;
        this.essentials = this.gradeData.essentials;
      }
    } catch (error) {
      console.error(error);
    }
  },
      logout() {
         Auth.logout();
      },
      showCurse(asignatura) {
         this.isDownloadable = true;
         this.isVideo = false;
         this.isAudio = false;
         this.isAsignatura = asignatura;
      },
      downloadIframe(url) {
         window.open(url, "_blank");
      },
      showIframe(id) {
         this.isIframe = false;
         this.iframeId = id;
         console.log(this.iframeId);
      },
      showVideo() {
         this.isDownloadable = false;
         this.isVideo = true;
         this.isAudio = false;
      },
      showAudio() {
         this.isDownloadable = false;
         this.isVideo = false;
         this.isAudio = true;
      },
      goToSpanishVersion() {
      this.$router.push({ path: `/mission/${this.missionId}/recursos` });
    }
   },
};
</script>
<style lang="scss">
.screen-container-book {
   width: 100vw;
   height: 100vh;
   justify-content: center;
   align-items: center;
   display: flex;
   background-size: 100% 100%;
   background-position: center center;
}

.background-activities {
   background-image: url("/img/bg-14.png");
   background-size: cover;
   width: 100%;
   min-height: 100vh;
   display: flex;
}

.sideBar {
   background: rgb(0, 0, 0);
   background: radial-gradient(circle,
         rgba(0, 0, 0, 0.8018557764902836) 0%,
         rgba(0, 0, 0, 0.8186624991793592) 35%,
         rgba(0, 0, 0, 0.7178221630449055) 80%);
   max-width: 500px;
   height: 100vh;
   max-height: 100vh;
   padding: 34px;
   margin: 0;
   font-family: Montserrat;
   font-weight: 800;
   color: #98d3fd;
   text-align: center;
   display: flex;
   flex-direction: column;

   h1 {
      font-family: "Montserrat";
      font-weight: 900;
      border-bottom: 2px solid #98d3fd;
      border-left: 2px solid #98d3fd;
      margin-bottom: 0;
      padding: 15px 0px 15px 15px;
   }

   .list {
      display: flex;
      flex-direction: column;
      margin: 0 0 0 17px;

      .button-container {
         button {
            width: 100%;

            &:hover {
               background: #98d3fd;
               transition: all 0.4s ease-in;
               color: #fff;
               text-shadow: 1.5px 1px #070704a1;
            }
         }
      }
   }
}

#contenedor {
   color: "red";

   &:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -23px;
      word-wrap: fit-content;
      background: url("/img/new/containerLogin.png");
      height: 30px;
   }
}
.imgmx {
    width: 35px;  // Ajusta el ancho como desees
    height: auto;  // Mantén la relación de aspecto
    margin-bottom: 2px;
    margin-left: 10px;
  }
.button-container {
   margin-left: -2px;
   display: flex;
   justify-content: flex-start;

   // &:first-child {
   //   border-top: 2px solid #98D3FD;
   // }
   &:last-child {
      button {
         margin-bottom: 5px;
      }
   }

   button {
      background: transparent;
      width: fit-content;
      height: fit-content;
      font-family: Montserrat;
      font-weight: 800;
      color: #98d3fd;
      border: none;
      position: relative;
      height: 50px;
      margin-bottom: 30px;
      text-align: left;
      border-left: 2px solid #98d3fd;
      min-width: 74%;
      text-transform: uppercase;
   }

   button:after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -23px;
      word-wrap: fit-content;
      background: url("/img/new/linea.png") repeat-x 100% 0;
      height: 30px;
   }
}

.container-actividades-buttons {
   overflow-y: auto;
   max-height: calc(100vh - 142px);
   margin-left: 30px;
   border-left: 2px solid;
   margin-top: -1px;
   border-top: 2px solid #020502;
}

.recursos {
   color: #fff;
   text-align: left;
   padding-left: 3.5rem;
}

.container-actividades-buttons::-webkit-scrollbar {
   width: 7px;
}

/* Track */
.container-actividades-buttons::-webkit-scrollbar-track {
   background: rgb(2, 24, 40);
}

/* Handle */
.container-actividades-buttons::-webkit-scrollbar-thumb {
   background: #98d3fd;
}

/* Handle on hover */
.container-actividades-buttons::-webkit-scrollbar-thumb:hover {
   background: #98d3fd;
}

.container-resources {
   justify-content: space-around;
   width: 100vw;
   height: 100vh;
   display: flex;
   flex-direction: column;

   button {
      font-size: 0.8em;
      background: #040403c9;
      margin: 0 5px;
      text-shadow: 1.5px 1px #070704a1;
      border: 1px solid white;
      color: #fff;
      cursor: pointer;
      padding: 0px 16px;
   }

   button:hover {
      background: #98d3fd;
   }

   .active {
      background: #98d3fd;
   }
}

.container-audio {
   height: 100%;
   width: 100%;
   max-height: calc(100vh - 2px);
   overflow-y: auto;
   display: grid;
   grid-template-columns: calc(50% - 5px) calc(50% - 5px);
   grid-template-rows: auto;
   overflow-y: auto;
   border: 2px solid #98d3fd;
   background: #20455fab;
   column-gap: 10px;
   row-gap: 10px;
   padding: 10px;

   &::-webkit-scrollbar {
      width: 7px;
   }

   &::-webkit-scrollbar-track {
      background: rgb(2, 24, 40);
   }

   &::-webkit-scrollbar-thumb {
      background: #98d3fd;
   }

   &::-webkit-scrollbar-thumb:hover {
      background: #98d3fd;
   }

   button {
      text-decoration: none;
      line-height: 1.6em;
      font-size: 2em;
      padding: 0.5em;
      display: block;
      color: white;
      font-family: "Montserrat";
      font-weight: 900;
      transition: all 0.9s ease-in;
      border-right: 2px solid #98d3fd !important;
      border-bottom: 2px solid #98d3fd !important;
      border: 2px transparent;
      background: #20455fab;
      cursor: pointer;

      &:hover {
         background: #6b94b1;
         color: #fff;
         cursor: pointer;
         transition: 3;
         transition: all 0.5s ease-out;
      }
   }
}

.container-videos {
   display: flex;
   flex-direction: column;
   width: 100%;
   justify-content: inherit;
   max-height: calc(100vh - 20px);
   overflow-y: auto;
   height: 100%;
   top: 0;
   margin-top: 13px;

   .container-buttons {
      position: inherit;
      height: 100%;
      display: grid;
      grid-template-columns: calc(50% - 5px) calc(50% - 5px);
      grid-template-rows: auto;
      overflow-y: auto;
      border: 2px solid #98d3fd;
      background: #20455fab;
      column-gap: 10px;
      row-gap: 10px;
      padding: 10px;

      &::-webkit-scrollbar {
         width: 7px;
      }

      &::-webkit-scrollbar-track {
         background: rgb(2, 24, 40);
      }

      &::-webkit-scrollbar-thumb {
         background: #98d3fd;
      }

      &::-webkit-scrollbar-thumb:hover {
         background: #98d3fd;
      }

      button {
         text-decoration: none;
         line-height: 1.6em;
         font-size: 2em;
         padding: 0.5em;
         display: block;
         color: white;
         font-family: "Montserrat";
         font-weight: 900;
         transition: all 0.9s ease-in;
         border-right: 2px solid #98d3fd !important;
         border-bottom: 2px solid #98d3fd !important;
         border: 2px transparent;
         background: #20455fab;

         &:hover {
            background: #6b94b1;
            color: #fff;
            cursor: selector;
            cursor: pointer;
            transition: 3;
            transition: all 0.5s ease-out;
         }
      }
   }

   .tab-trim {
      display: flex;
      padding: 9px;

      button {
         background: #040403c9;
         margin: 0 5px;
         text-shadow: 1.5px 1px #070704a1;
         border: 1px solid white;
      }

      button:hover {
         background: #98d3fd;
      }

      .active {
         background: #98d3fd;
      }
   }

   h2 {
      button {
         background-color: #98d3fd52;
         /* border: 2px solid #98d3fd; */
         border-radius: 4px;
         cursor: pointer;
      }
   }

   button {
      background-color: transparent;
      border: none;
      color: #fff;
      font-family: Montserrat;
      font-weight: 800;
      font-size: 21px;
      padding: 7px 16px;
      background-color: #98d3fd0a;
      padding: auto;
   }

   a {
      background-color: transparent;
      border: none;
      color: #fff;
      font-family: Montserrat;
      font-weight: 800;
      font-size: 21px;
      padding: 12px 0;
      background-color: #98d3fd0a;
   }

   a:hover {
      color: #fff;
      text-decoration: none;
      background-color: rgba(0, 0, 0, 0.801856);
   }
}
</style>
